import Axios from 'axios'

if (window.location.hostname == 'rhadc.com.ar' || window.location.hostname == 'www.rhadc.com.ar') {
    Axios.defaults.baseURL = "https://api.rhadc.com.ar/api";
} else if (window.location.hostname == 'prueba.pampadev.com.ar') {
    Axios.defaults.baseURL = "https://apiprueba.pampadev.com.ar/api";
} else {
    Axios.defaults.baseURL = "http://localhost:8000/api";
}

const token = localStorage.getItem('access_token')
if (token) {
    Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Interceptor para agregar token a cada request
Axios.interceptors.request.use(function(config) {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});

Axios.interceptors.response.use(function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function(error) {
    if (error.response.status == 500) {
        error.status = 500
        return new Promise(function(resolve, reject) {
            throw error;
        });
    }
    return new Promise(function(resolve, reject) {
        throw error;
    });
});